import React from 'react';
import { Dialog, DialogContent, Button, withStyles } from "@material-ui/core";
import modalBgImg from "../../../../assets/img/upgrade_modal_back.png";
import localization from '../../../../config/localization';

const styles = {
  dialogPaper: {
      borderRadius: '10px',
      height: '300px',
      maxWidth: '750px',
      backgroundColor: '#353535'
  },
  dialogPaperMobile: {
    borderRadius: '10px',
    backgroundColor: '#353535',
    fontSize: '0.8em'
  }
};

const ModalButton = withStyles({
  root: {
    backgroundColor: 'black',
    color: 'white',
    minHeight: '30px',
    textTransform: 'none',
    padding: '5px 30px',
    '&:hover': {
      backgroundColor: 'black'
    },
    '&:disabled': {
      backgroundColor: 'grey',
      color: 'lightgrey'
    }
  },
})(Button);

class Safari14Modal extends React.Component {
  constructor(props) {
    super(props);
  }

  handleModalClose = () => {
    this.props.onClose && this.props.onClose();
  }

  render = () => {
    const { classes } = this.props;
    let isMobile = window.innerWidth < 450;
    return (
      <Dialog
        disableEnforceFocus
        style={{zIndex: 1400}}
        open={this.props.open} // TODO: add condition to showModal
        onEscapeKeyDown={this.handleModalClose}
        fullWidth
        classes={{paper: isMobile ? classes.dialogPaperMobile : classes.dialogPaper}}
        maxWidth="md"
      >
        <div style={{
          // minHeight: "225px",
          backgroundImage: `url(${modalBgImg})`,
          backgroundSize: '100% 100%',
          borderRadius: '10px',
          color: "white",
          height: '100%',
          overflow: 'auto'
        }}>
          <DialogContent style={{padding: isMobile ? '20px' : '40px', height: '100%'}}>
            <div className="modal-step-container">
              <div className="modal-step-content" style={{justifyContent: 'center'}}>
                <div className="modal-title">{localization.get("safari_14_bug.title")}</div>
                <div className="modal-text">{localization.get("safari_14_bug.text")}</div>
                <div style={{paddingBottom: '10px'}}>
                  <div className="modal-subtitle-item">{localization.get("safari_14_bug.item_1")}</div>
                  <div className="modal-subtitle-item">{localization.get("safari_14_bug.item_2")}</div>
                </div>
              </div>
              <div className="modal-step-buttons" style={{justifyContent: 'center'}}>
                <ModalButton onClick={() => this.handleModalClose()}>{localization.get("safari_14_bug.button")}</ModalButton>
              </div>
            </div>
          </DialogContent>
        </div>
      </Dialog>
    );
  }
}

export default withStyles(styles)(Safari14Modal);